import * as STUDENTACTIONS from '../../actions/student.action'

const initialState = {
    loading: false,
    success: false,
    failure: false,
    status:'',
    status_code:'',
    message:'',
    data:[]
}

export default function returnstate(state = initialState, action) {

    switch (action.type) {
        case STUDENTACTIONS.CREATE_APPLICATION.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                failure: false,
            };
        case STUDENTACTIONS.CREATE_APPLICATION.SUCCESS:     
        return {
                ...state,
                loading: false,
                success: true,
                failure: false,
                status:action.payload.status,
                status_code:action.payload.status_code,
                message:action.payload.message,
                data:action.payload.data
            };

        case STUDENTACTIONS.CREATE_APPLICATION.FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                failure: true,
                status:action.payload.status,
                status_code:action.payload.status_code,
                message:action.payload.message,
                data:action.payload.data
            };
            case STUDENTACTIONS.RESET_CREATE_APPLICATION.SUCCESS:
                return {
                    ...state,
                    loading: false,
                    success: false,
                    failure: false,
                    status:'',
                    status_code:'',
                    message:'',
                    data:[]
                };
        default: return state
    }
}